export interface ILayoutResourceStrings {
    activeVisitations: string;
    placeholderHeader: string;
    placeholderBody: string;
    placeholderBold: string;
    placeholderBodySecond: string;
}

export interface ILayoutResources {
    [key: string]: ILayoutResourceStrings;
}

const engb = "en-GB";
const etee = "et-EE";
const ruru = "ru-RU";

export const ActiveVisitationsTranslations: ILayoutResources = {
    [engb]: {
        activeVisitations: "Active visitations",
        placeholderHeader: "Theres nothing here...",
        placeholderBody: "No active visitations to display. Refresh the page or create an entry from the",
        placeholderBold: "Add visitation",
        placeholderBodySecond: " page"
    },
    [ruru]: {
        activeVisitations: "Активные посещения",
        placeholderHeader: "Здесь сейчас ничего...",
        placeholderBody: "Нет записей об активных посетителях. Пожалуйста, обновите страницу или сделайте запись в окне ",
        placeholderBold: "Добавить посещение",
        placeholderBodySecond: ""
    },
    [etee]: {
        activeVisitations: "Aktiivsed külastused",
        placeholderHeader: "Siin pole hetkel midagi...",
        placeholderBody: "Aktiivsed külastussissekanded puuduvad. Värskenda lehte või tee sissekanne",
        placeholderBold: "Lisa külastus",
        placeholderBodySecond: " aknast"
    }
};

export default ActiveVisitationsTranslations;
